export const TOGGLE_FILTER_NAVIGATION = 'TOGGLE_FILTER_NAVIGATION';

export const toggleFilterNavigation = checked => {
    return {
        type: TOGGLE_FILTER_NAVIGATION,
        show: checked
    }
}